<template>
  <div class="studentRequirementSubmissionEdit">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'studentRequirementSubmission', params: {} }"
      >
        Student Submission
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :to="{ name: 'studentRequirementSubmissionEdit', params: { id: id } }"
      >
        Edit Student Submission
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title>Edit Student Submission</v-card-title>
      <v-card-text>
        <studentRequirementSubmission-form
          :id="id"
        ></studentRequirementSubmission-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import StudentRequirementSubmissionForm from "./StudentRequirementSubmissionForm.vue";

export default {
  name: "studentRequirementSubmission",
  data() {
    return {
      id: null
    };
  },
  components: {
    StudentRequirementSubmissionForm
  },
  created() {
    this.id = this.$route.params.id;
    this.$emit("showParent", false);
  }
};
</script>
